import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hub-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
